<template>
  <div class="calenderWork">
    <div class="calenderbox">
    <button class="calcbtn" @click="calc=true">自訂時間</button>
    <vc-calendar
      class="custom-calendar max-w-full"
      :masks="masks"
      :attributes="attributes"
      disable-page-swipe
      is-expanded
      @update:to-page="cenlendar=$event"
    >
    <template v-slot:day-content="{ day, attributes }">
      <div class="dayCube" @click="fnSelected(day.id)" :class="[
      selected===day.id?'selected': '',
      attributes&&attributes[0]&&attributes[0].customData.isCal===false?'':'calced',
      moment(day.id).isBefore(moment().startOf('day'))?'pass': '',
      moment(day.id).isAfter(moment().endOf('day'))?'comming': ''
      ]">
        <span :class="holidays.includes(day.id)?'is-holiday':''">{{day.day}}</span>
        <div :style="{textAlign: 'start'}"
        v-for="(attr, a) in attributes"
        :class="attr.customData.class"
        :key="a" v-html="attr.customData.title"></div>
      </div>
    </template>
    </vc-calendar></div>
    <div class="daily">
    <div class="dailyStatus2"></div>
    <div class="dailyStatus">
      <div class="icon"></div>
      <div v-if="selected">
        <div class="datetime">{{toDate(selected)}}<br>{{toWeekday(selected)}}</div>
        <div v-if="itemSelect" class="workerlist">
          <div v-for="t in times" :key="t">
            <div>{{t}}</div>
            <div>
              <div>
                <div>內場</div>
                <div>
                  <div v-for="({name}, n) in (itemSelect.data[t]?.back || [])" :key="`back-${n}`">{{name}}</div>
                </div>
              </div>
              <div>
                <div>外場</div>
                <div>
                  <div v-for="({name}, n) in (itemSelect.data[t]?.front || [])" :key="`front-${n}`">{{name}}</div>
                </div>
              </div>
              <div>
                <div>內場PT</div>
                <div>
                  <div v-for="({name}, n) in (itemSelect.data[t]?.backPT || [])" :key="`backPT-${n}`">{{name}}</div>
                </div>
              </div>
              <div>
                <div>外場PT</div>
                <div>
                  <div v-for="({name}, n) in (itemSelect.data[t]?.frontPT || [])" :key="`frontPT-${n}`">{{name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <dialogC :show="calc" :width="517" :height="240" label="請選擇結算區間"
    @close="calc=false">
      <vue-ctk-date-time-picker :range="true" v-model="range"
        :color="'var(--color-pri)'"
        :no-label="true"
        :input-size="'sm'"
        :label="'選取時間範圍'"
        :format="'YYYY-MM-DD'"
        :formatted="'YYYY-MM-DD'"
        @input="setDate()"
        id="restWorkerRange"
        />
      <button class="savebtn" :style="{
        marginBottom: '20px'
      }"
      @click="calculate">確認</button>
    </dialogC>
  </div>
</template>

<script>

import dialogC from '../components/dialog.vue'
import { getapi, postapi } from '../store/fetch'
const wdy = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']

export default {
  props: ['store', 'restaurantInfo'],
  components: {
    dialogC
  },
  data () {
    return {
      range: {
        start: this.moment().startOf('month').format('yyyy-MM-DD'),
        end: this.moment().endOf('month').format('yyyy-MM-DD')
      },
      calc: false,
      masks: {
        weekdays: 'WWW'
      },
      cenlendar: {
        month: this.moment().month(),
        year: this.moment().year()
      },
      attributes: [
      ],
      holidays: [],
      selected: null,
      bookstatus: [],
      itemSelect: null,
      restStatus: []
    }
  },
  watch: {
    cenlendar () {
      this.updateStatus()
    },
    selected () {
      if (this.selected) {
        this.updateItemSelect()
      }
    },
    itemSelect () {
      // if (this.itemSelect && this.selected) {
      //   this.getAvailables()
      // }
    }
  },
  computed: {
    restTakeout () { return this.restaurantInfo.restTakeout },
    restDeliver () { return this.restaurantInfo.restDeliver },
    restTakeoutHoliday () { return this.restaurantInfo.restTakeoutHoliday },
    restDeliverHoliday () { return this.restaurantInfo.restDeliverHoliday },
    restTimeWeekday () { return this.restaurantInfo.restTimeWeekday },
    restTimeHoliday () { return this.restaurantInfo.restTimeHoliday },
    times () {
      const times = Object.keys(this.itemSelect.data)
      times.sort((a, b) => this.moment(a, 'HH:mm').isAfter(this.moment(b, 'HH:mm')) ? 1 : -1)
      return times
    }
  },
  async mounted () {
    // this.restStatus = await getapi('restStatus')
    this.getHoliday()
    this.updateStatus()
  },
  methods: {
    async calculate () {
      const r = await postapi('restaurant/calculate', {
        start: this.moment(this.range.start).startOf('day').toISOString(),
        end: this.moment(this.range.end).add(1, 'day').startOf('day').toISOString(),
        store: this.store
      })
      if (r) {
        this.calc = false
        setTimeout(() => {
          this.updateStatus()
        }, 600)
      }
    },
    async updateItemSelect () {
      const data = this.bookstatus[this.selected]
      const isHoliday = this.holidays.includes(this.toDate(this.selected))
      const wd = this.moment(this.selected).weekday()
      const isWeekend = wd === 0 || wd === 6 || wd === 7
      // console.log(availables, 'availables')
      this.itemSelect = {
        isHoliday: isHoliday || isWeekend,
        data: data
      }
    },
    // async getAvailables () {
    //   this.availables = await getapi('restaurant/available2?' + new URLSearchParams({
    //     date: this.moment(this.selected).startOf('day').toISOString(),
    //     isHoliday: this.itemSelect.isHoliday,
    //     store: this.store
    //   }))
    // },
    // getClosed (date) {
    //   const isHoliday = this.holidays.includes(this.toDate(date))
    //   const isWeekend = this.moment(date).weekday() === 0 || this.moment(date).weekday() === 6 || this.moment(date).weekday() === 7
    //   const x = this.restStatus.find(e => this.toDate(e.date) === date)
    //   const c = (isHoliday || isWeekend) ? this.restTimeHoliday : this.restTimeWeekday
    //   const c2 = x ? x.closed : []
    //   // console.log(date, (isHoliday || isWeekend), c, c2)
    //   return c2.filter(e => c.includes(e)).length === c.length
    // },
    async updateStatus () {
      const bookstatus = await getapi('restaurant/attendance?' + new URLSearchParams({
        start: this.moment(`${this.cenlendar.year}-${this.cenlendar.month}-01`).startOf('day').toISOString(),
        end: this.moment(`${this.cenlendar.year}-${this.cenlendar.month}-30`).endOf('month').add(1, 'day').startOf('day').toISOString(),
        store: this.store
      }))
      // const bookAvaStatus = await getapi('restaurant/available2Month?' + new URLSearchParams({
      //   start: this.moment(`${this.cenlendar.year}-${this.cenlendar.month}-01`).startOf('day').toISOString(),
      //   end: this.moment(`${this.cenlendar.year}-${this.cenlendar.month}-30`).endOf('month').add(1, 'day').startOf('day').toISOString(),
      //   store: this.store
      // }))
      // console.table(bookstatus)
      // console.table(bookAvaStatus)
      this.attributes = []
      this.bookstatus = bookstatus
      this.attributes = Object.keys(bookstatus).map(k => {
        const isHoliday = this.holidays.includes(this.toDate(k))
        const isWeekend = this.moment(k).weekday() === 0 || this.moment(k).weekday() === 6 || this.moment(k).weekday() === 7
        const e = Object.keys(bookstatus[k]).length === 0 ? {} : Object.assign({}, bookstatus[k])
        const f = Array.from(new Set([].concat(...Object.values(e).map(a => a.front.map(b => b._id))))).length
        const b = Array.from(new Set([].concat(...Object.values(e).map(a => a.back.map(b => b._id))))).length
        const fp = Array.from(new Set([].concat(...Object.values(e).map(a => a.frontPT.map(b => b._id))))).length
        const bp = Array.from(new Set([].concat(...Object.values(e).map(a => a.backPT.map(b => b._id))))).length
        const isCal = Array.from(new Set([].concat(...Object.values(e).map(a => a.backNum || a.frontNum)))).filter(a => a).length
        // console.log('bookstatus', this.moment(k).format('yyyy-MM-DD'), isCal, isCal.length > 0)
        return {
          customData: {
            title: (f || b || bp || fp) ? `
            <div>內場 <span>${b}</span> 人</div>
            <div>外場 <span>${f}</span> 人</div>
            <div>內PT <span>${bp}</span>  人</div>
            <div>外PT <span>${fp}</span>  人</div>` : '',
            class: 'gridinRest' + (isHoliday ? ' isHoliday' : '') + (isWeekend ? ' isHoliday' : ''),
            isCal: isCal > 0
          },
          dates: k
        }
      })
    },
    toWeekday (date) {
      return wdy[this.moment(date).weekday()]
    },
    fnSelected (id) {
      this.selected = id
    },
    async getHoliday () {
      const holidays = await getapi('holidays')
      this.holidays = holidays.map(e => this.moment(e.date).format('YYYY-MM-DD'))
    }
  }
}
</script>
<style lang="scss">
.calenderWork {
  #restWorkerRange-wrapper {
    width: 450px;
    margin-block: 20px;
    position: relative;
    &>.field::after {
    mask-image: url(./calendar2.svg);
    content: '';
    position: absolute;
    top: 0;
    right: 0px;
    width: 36px;
    height: 36px;
    -webkit-mask-size: contain;
    mask-size: contain;
    background-color: var(--color-checked);
    -webkit-mask-size: 22px;
    mask-size: 22px;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: 8px 9px;
    mask-position: 8px 9px;
    }
    &>.field>button {
      margin-right: 40px;
    }
  }
  #restWorkerRange-input {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #517FA4;
  }
  .custom-calendar {
    border: none;
  }
  .vc-arrows-container {
    top: 5px;
    padding-inline: 360px;
  }
  .vc-header {
    height: 55px;
    padding: 10px 18px 10px 18px;
  }
  .vc-arrow {
    color: var(--color-checked);
  }
  .vc-title {
    color: var(--color-checked);
    font-size: 24px;
    padding: 10px 18px 10px 18px;
  }
  .gridinRest {
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0.1em;
    color: #848484;
    &>div{
      height: 27px;
    }
    span {
      display: inline-flex;
      width: 70px;
      justify-content: center;
      font-weight: 700;
      font-size: 18px;
      text-align: center;
      letter-spacing: 0.1em;
      color: #000000;
    }
  }
  .full {
    width: 64px;
    height: 64px;
    background: var(--color-confirm);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    margin-inline: auto;
    margin-top: 10px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
  }
  .vc-weekday {
    color: #FFFFFF;
  }
  .vc-weeks {
    border-radius: 5px;
    background-color: var(--color-checked);
    gap: 1px;
  }
  .vc-day {
    width: 100%;
    box-sizing: border-box;
    min-height: 100px;
    height: 143px;
    background-color: #FFFFFF;
  }
  .hrdeco {
    height: 12px;
    width: 100%;
    background-color: var(--color-checked);
    mask-image: url(./hrdeco.svg);
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    border: none;
    margin-block: 20px;
  }
  .table {
    display: flex;
    margin-inline: 30px;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .tr {
    width: 335px;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    padding: 19px 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &>div:nth-child(1) {
      display: grid;
      grid-template-columns: 100px 71px 71px;
      gap: 20px;
      height: 40px!important;
    }
    &>div:nth-child(2) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      // grid-template-rows: repeat(2, 1fr);
      width: 100%;
      height: 100%;
      gap: 20px 60px;
      font-size: 14px;
      color: #959595;
      letter-spacing: .1em;
      line-height: 16px;
      margin-top: 13px;
      &>div{
        display: flex;
        align-items: flex-end;
        justify-content: center;
        span {
          display: inline-flex;
          width: 60px;
          text-align: center;
          justify-content: center;
          font-size: 20px;
          line-height: 23px;
          letter-spacing: .1em;
          color: #000000;
        }
      }
    }
    .td {
      display: table-cell;
      height: 40px!important;
      box-sizing: border-box;
      &:nth-child(1)>div {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        letter-spacing: 0.1em;
        color: var(--color-checked);
        width: 100px;
        height: 40px;
        border: 1.5px solid var(--color-checked);
        box-sizing: border-box;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) >div, &:nth-child(3)>div {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        letter-spacing: 0.1em;
        color: #FFFFFF;
        width: 71px;
        height: 40px;
        background-color: #DADADA;
        box-sizing: border-box;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) >div.selected {
        background-color: var(--color-tab);
      }
      &:nth-child(3) >div.selected {
        background-color: var(--color-confirm);
      }
    }
  }
  .tr2 {
    display: grid;
    height: 40px!important;
    grid-template-columns: 100px 71px 71px;
    gap: 20px;
    border-bottom: 1.5px solid var(--color-checked);
    .td {
      display: table-cell;
      height: 40px!important;
      box-sizing: border-box;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      &:nth-child(1)>div {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        letter-spacing: 0.1em;
        color: var(--color-checked);
        width: 100px;
        height: 40px;
        // border: 1.5px solid var(--color-checked);
        box-sizing: border-box;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) >div, &:nth-child(3)>div {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        letter-spacing: 0.1em;
        width: 71px;
        height: 40px;
        box-sizing: border-box;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2)>div::before {
        content: '大';
        font-size: 16px;
        margin-right: 6px;
      }
      &:nth-child(3)>div::before {
        content: '孩';
        font-size: 16px;
        margin-right: 6px;
      }
    }
  }
  &>.dayCube>span:nth-child(1) {
      font-weight: 500;
    }
  .weekday-1, .weekday-7 {
    &>.dayCube>span:nth-child(1) {
      font-weight: 900;
    }
  }
  .in-next-month, .in-prev-month {
    background-color: #FFFFFFDD;
  }
}
</style>
<style lang="scss" scoped>
.savebtn {
  background-color: #E37878;
  width: 100px;
  height: 35px;
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  border: none;
}
.calenderbox {
  position: relative;
}
.calcbtn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
  width: 120px;
  height: 40px;
  background: #517FA4;
  border-radius: 3px;
  border: none;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
}
.workerlist {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 39px;
  z-index: 5;
  padding: 10px 20px;
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  &>div{
    background: #FFFFFF;
    width: 335px;
    min-height: fit-content;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    padding: 19px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 15px;
    &>div:nth-child(1) {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    width: 100px;
    height: 40px;
    border: 1.5px solid #517FA4;
    border-radius: 3px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #517FA4;
    }
    &>div:nth-child(2) {
      display: flex;
      flex-direction: column;
      gap: 23px;
    }
    &>div:nth-child(2)>div {
      display: flex;
      flex-direction: column;
      gap: 8.5px;
      &>div:nth-child(1) {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;
        width: 280px;
        height: 30px;
        background: #517FA4;
        border-radius: 20px;
        font-size: 14px;
        letter-spacing: 0.1em;
        color: #FFFFFF;
      }
      &>div:nth-child(2) {
        display: flex;
        flex-direction: row;
        gap: 18px;
        flex-wrap: wrap;
        &>div {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        // padding: 10px 18px;
        gap: 25px;
        width: 80px;
        height: 30px;
        background: #E5E5E5;
        border-radius: 50px;
        font-size: 14px;
        letter-spacing: 0.1em;
        color: #848484;
        }
      }
    }
  }
}
.calenderWork {
  padding: 25px 37px;
  display: grid;
  grid-template-columns:  1fr 380px;
  gap: 47px;
}
.contentSelected {
  overflow-y: auto;
  max-height: calc(100vh - 373px);
  color: var(--color-letter);
  z-index: 5;
  position: relative;
  padding: 16px;
  padding-top: 35px;
  .alldisabled {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 282px;
    margin: auto;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);

  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
    background-color: #85CA9E;
    &:checked {
      background-color: #E37878;
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      right: 2px;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      left: 2px;
    }
  }
}
.contentSelected.counts {
  overflow-y: auto;
  max-height: calc(100vh - 373px);
  color: var(--color-letter);
  z-index: 5;
  position: relative;
  padding: 22px;
  padding-top: 35px;
  text-align: start;
  display: flex;
  flex-direction: column;
  gap: 15px;
  &>:nth-child(1) {
    padding-inline: 15px;
    font-size: 18px;
    letter-spacing: .1em;
  }
  &>:nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 25px;
  }
}
.datetime {
  width: 100%;
  color: var(--color-checked);
  position: relative;
  z-index: 5;
  padding-top: 47px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.1em;
}
.icon {
  width: 71px;
  height: 71px;
  background-image: url(./celender.svg);
  border-radius: 50%;
  background-color: var(--color-checked);
  z-index: 5;
  position: absolute;
  top: -35.5px;
  left: 50%;
  transform: translateX(-50%);
}
.daily {
  position: relative;
  z-index: 1;
}
.dailyStatus2 {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 45px;
  width: 380px;
  height: calc(100% - 45px);
  border-radius: 10px;
  background-color: transparent;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: transparent;
    z-index: -1;
    transform: translateX(-50%);
    border-radius: 50%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
.dailyStatus {
  z-index: 3;
  margin-top: 45px;
  width: 380px;
  height: calc(100% - 45px);
  z-index: 3;
  position: relative;
  border-radius: 10px;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: #FFFFFF;
    z-index: 2;
    transform: translateX(-50%);
    border-radius: 50%;

  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: -1;
  }
}
.dayCube {
  height: 100%;
  box-sizing: border-box;
  &.disabled {
    // border: 2px solid var(--color-checked);
    background-color: #CDCDCD99;
  }
  &>span:nth-child(1) {
    color: var(--color-checked);
    font-weight: 700;
  }
  &.calced {
    background-color: #F6FFF3;
  }
  &.selected {
    border: 2px solid var(--color-checked);
    background-color: var(--color-infobox);
  }
}
.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 36.7px;
    mask-image: url(./celender3.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-checked);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-checked);
  gap: 10px;
}
.title > input[type=radio] {
  width: 120px;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);  }

  &:checked {
    background-color: var(--color-checked);
  }

}
</style>
